import { render, staticRenderFns } from "./ChatSessionSelector.vue?vue&type=template&id=70837897&scoped=true"
import script from "./ChatSessionSelector.vue?vue&type=script&lang=js"
export * from "./ChatSessionSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatSessionSelector.vue?vue&type=style&index=0&id=70837897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70837897",
  null
  
)

export default component.exports